import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { postSicuro } from '../services/offline';
import { FirmaDdtModalSeparato } from './DdtPage';

const fmtData = d => d ? String(d).substring(0,10).split('-').reverse().join('/') : '\u2014';
const CHIAVE_CACHE = 'quindi_ddt_assegnati';

export default function MieiDdtPage() {
  const [righe, setRighe]   = useState([]);
  const [loading, setLoad]  = useState(true);
  const [offline, setOff]   = useState(!navigator.onLine);
  const [soloDaFirmare, setSolo] = useState(false);
  const [firmaSu, setFirmaSu] = useState(null);   // riga in firma
  const [aperta, setAperta] = useState(null);     // riga di cui vedere il dettaglio
  const [busy, setBusy] = useState(false);

  const carica = async () => {
    setLoad(true);
    try {
      const r = await api.get('/ddt-assegnazioni');
      const dati = r.data?.data || [];
      setRighe(dati);
      try { localStorage.setItem(CHIAVE_CACHE, JSON.stringify(dati)); } catch (e) {}
    } catch (e) {
      try {
        const cache = JSON.parse(localStorage.getItem(CHIAVE_CACHE) || '[]');
        setRighe(cache);
      } catch (e2) { setRighe([]); }
    } finally { setLoad(false); }
  };

  useEffect(() => {
    carica();
    const on  = () => { setOff(false); carica(); };
    const off = () => setOff(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  const confermaFirma = async (firmaCliente, nomeFirm, firmaTecnico) => {
    const r = firmaSu;
    setFirmaSu(null); setBusy(true);
    try {
      const esito = await postSicuro(`/ddt/${r.ficDdtId}/firma`, {
        firma: firmaCliente || null,
        nome_firmatario: nomeFirm || null,
        firma_tecnico: firmaTecnico || null,
        firmata_il: new Date().toISOString().slice(0,19).replace('T',' '),
        firmata_offline: !navigator.onLine,
      });

      // Aggiorna subito la riga: online o accodata, per il tecnico e' fatta
      setRighe(v => v.map(x => x.ficDdtId === r.ficDdtId
        ? { ...x, firmatoCliente: true, firmatoTecnico: !!firmaTecnico }
        : x));

      if (!esito.inviato) {
        if (esito.persa) {
          alert('ATTENZIONE: memoria del dispositivo piena, la firma NON e\' stata salvata. Libera spazio e ripeti.');
          setRighe(v => v.map(x => x.ficDdtId === r.ficDdtId
            ? { ...x, firmatoCliente: false } : x));
        } else {
          alert('Firma salvata sul dispositivo. Verra\' inviata al ritorno della rete.');
        }
      }
    } catch (e) {
      alert('Errore: ' + (e?.response?.data?.error || e.message));
    } finally { setBusy(false); }
  };

  const filtrate = righe.filter(r => !soloDaFirmare || !r.firmatoCliente);
  const th = {padding:'8px 10px', background:'#f1f5f9', fontSize:11, textAlign:'left'};

  return (
    <div className="page-content">
      <div style={{display:'flex',gap:12,marginBottom:16,alignItems:'center',flexWrap:'wrap'}}>
        <h2 style={{margin:0,fontSize:18}}>DDT assegnati a me</h2>
        <label style={{fontSize:13,color:'#6b7280',cursor:'pointer'}}>
          <input type="checkbox" checked={soloDaFirmare}
            onChange={e=>setSolo(e.target.checked)} /> Solo da firmare
        </label>
        <span style={{marginLeft:'auto',color:'#9ca3af',fontSize:13}}>{filtrate.length} DDT</span>
      </div>

      {offline && (
        <div style={{background:'#fef9c3',color:'#854d0e',padding:'8px 12px',
                     borderRadius:8,fontSize:13,marginBottom:12}}>
          Offline &mdash; stai vedendo l&apos;ultimo elenco scaricato.
        </div>
      )}

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card" style={{padding:0}}>
          <div className="table-wrap">
            <table className="q-table">
              <thead><tr>
                <th style={th}>N.</th>
                <th style={th}>Data</th>
                <th style={th}>Cliente</th>
                <th style={{...th, textAlign:'center'}}>Stato</th>
                <th style={th}></th>
              </tr></thead>
              <tbody>
                {filtrate.length === 0 && (
                  <tr><td colSpan={5} style={{textAlign:'center',color:'#9ca3af',padding:32}}>
                    Nessun DDT assegnato
                  </td></tr>
                )}
                {filtrate.map(r=>(
                  <tr key={r.ficDdtId} style={{cursor:'pointer'}}
                      onClick={()=>setAperta(r)}>
                    <td><strong>{r.ddtNumero || '\u2014'}</strong></td>
                    <td style={{fontSize:12}}>{fmtData(r.ddtData)}</td>
                    <td>{r.clienteNome || '\u2014'}</td>
                    <td style={{textAlign:'center'}}>
                      {r.firmatoCliente
                        ? <span className="badge badge-green">Firmato</span>
                        : <span className="badge" style={{background:'#fef9c3',color:'#854d0e'}}>Da firmare</span>}
                    </td>
                    <td onClick={e=>e.stopPropagation()}>
                      {!r.firmatoCliente && (
                        <button className="btn btn-primary btn-sm" disabled={busy}
                          onClick={()=>setFirmaSu(r)}>Firma</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {aperta && (
        <DettaglioTecnico riga={aperta} onClose={()=>setAperta(null)}
          onFirma={()=>{ const r = aperta; setAperta(null); setFirmaSu(r); }} />
      )}

      {firmaSu && (
        <FirmaDdtModalSeparato
          onClose={()=>setFirmaSu(null)}
          onConfirm={confermaFirma} />
      )}
    </div>
  );
}

function DettaglioTecnico({ riga, onClose, onFirma }) {
  let dati = null;
  try { dati = riga.contenutoJson ? JSON.parse(riga.contenutoJson) : null; } catch (e) {}

  const th = {padding:'6px 8px', background:'#f1f5f9', fontSize:11, textAlign:'left'};

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',
                 alignItems:'center',justifyContent:'center',zIndex:1000,padding:20}}
      onClick={onClose}>
      <div style={{background:'#fff',borderRadius:12,padding:24,width:'100%',
                   maxWidth:560,maxHeight:'90vh',overflowY:'auto'}}
        onClick={e=>e.stopPropagation()}>

        <h3 style={{margin:'0 0 4px',fontSize:16}}>
          DDT N. {riga.ddtNumero || '\u2014'}
        </h3>
        <p style={{margin:'0 0 16px',fontSize:13,color:'#6b7280'}}>
          {riga.clienteNome || '\u2014'}
        </p>

        {!dati && (
          <div style={{background:'#fef9c3',color:'#854d0e',padding:'10px 12px',
                       borderRadius:8,fontSize:13,marginBottom:12}}>
            Dettaglio non disponibile. Chiedi in segreteria di riassegnare il DDT
            per scaricare il contenuto.
          </div>
        )}

        {dati && (
          <>
            {(dati.indirizzo || dati.citta) && (
              <div style={{marginBottom:12,fontSize:13}}>
                <strong>Consegna:</strong>{' '}
                {[dati.indirizzo, dati.cap, dati.citta].filter(Boolean).join(' \u00b7 ')}
              </div>
            )}
            {dati.oggetto && (
              <div style={{marginBottom:12,fontSize:13}}>
                <strong>Oggetto:</strong> {dati.oggetto}
              </div>
            )}

            <table className="q-table" style={{width:'100%'}}>
              <thead><tr>
                <th style={th}>Articolo</th>
                <th style={{...th, textAlign:'right', width:80}}>Q.ta</th>
              </tr></thead>
              <tbody>
                {(dati.righe || []).length === 0 && (
                  <tr><td colSpan={2} style={{textAlign:'center',color:'#9ca3af',padding:20}}>
                    Nessuna riga
                  </td></tr>
                )}
                {(dati.righe || []).map((r, i)=>(
                  <tr key={i}>
                    <td style={{fontSize:13}}>
                      <strong>{r.descrizione}</strong>
                      {r.dettaglio && (
                        <div style={{fontSize:11,color:'#6b7280'}}>{r.dettaglio}</div>
                      )}
                    </td>
                    <td style={{textAlign:'right',fontSize:13,whiteSpace:'nowrap'}}>
                      {r.quantita} {r.um || ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        <div style={{display:'flex',gap:8,marginTop:20}}>
          <div style={{flex:1}} />
          <button className="btn btn-secondary" onClick={onClose}>Chiudi</button>
          {!riga.firmatoCliente && (
            <button className="btn btn-primary" onClick={onFirma}>Firma</button>
          )}
        </div>
      </div>
    </div>
  );
}
